import { useCallback } from 'react';

import { VOID_FUNCTION } from 'constants/index';

const DEFAULT_TRANSFORM = (value) => {
  return value;
};

const generatePayload = ({ event, name, target: targetParam }) => {
  if (targetParam === 'broadcast') {
    return name ? { [name]: event } : event;
  }

  const { target } = event;
  const { checked, value } = target ?? {};

  if (targetParam === 'checked') {
    return name ? { [name]: checked } : checked;
  }

  return name ? { [name]: value } : value;
};

/**
 * @param {any} Component
 * @param {object} options
 * @param {function} [options.transform]
 * @param {'broadcast' | 'checked' | 'value'} options.target
 * */
export const withNamedEvent = (Component, { transform = DEFAULT_TRANSFORM, target } = {}) => {
  const { displayName: displayNameComponent, name: nameComponent } = Component;

  const WithNamedEvent = ({ name, onChange: onChangeProp = VOID_FUNCTION, ...rest }) => {
    const onChange = useCallback(
      (event) => {
        const payload = generatePayload({ event, name, target });
        const result = transform(payload);

        onChangeProp(result);
      },
      [onChangeProp, name]
    );

    // eslint-disable-next-line react/react-in-jsx-scope
    return <Component {...rest} onChange={onChange} />;
  };

  WithNamedEvent.displayName = `withNamedEvent(${displayNameComponent || nameComponent})`;

  return WithNamedEvent;
};
